<section id="testimonials" class="section testimonials-section section-bg-alt">
  <div class="container">
    <div class="section-title">Trusted By Leading Businesses</div>
    <p class="section-subtitle">
      See why thousands of companies choose KOTHA as their primary
      telecommunications partner.
    </p>

    <div class="trust-logos">
      @if (portfolios && portfolios.length === 0) {
        <div class="no-data-fallback" style="grid-column: 1 / -1;">No data found.</div>
      }
      @for (portfolio of portfolios || []; track portfolio) {
        <div class="logo-placeholder">
          {{ portfolio.title }}
        </div>
      }
    </div>

    <div class="testimonials-grid">
      @if (testimonials && testimonials.length === 0) {
        <div class="no-data-fallback">No data found.</div>
      }
      @for (item of testimonials || []; track item; let i = $index) {
        <div
          class="glass-card testimonial-card reveal"
          [ngClass]="'delay-' + ((i % 3) + 1) * 100"
        >
          <div class="rating">
            @for (star of [1, 2, 3, 4, 5]; track star) {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="currentColor"
                stroke="none"
                class="star-icon"
              >
                <polygon
                  points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
                ></polygon>
              </svg>
            }
          </div>
          <p class="quote">"{{ stripHtml(item.message) }}"</p>
          <div class="author-info">
            <div class="author-avatar">
              @if (item.image) {
                <img
                  [src]="item.image"
                  [alt]="item.name"
                  style="
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    object-fit: cover;
                  "
                />
              }
              @if (!item.image) {
                <span>{{ getInitial(item.name) }}</span>
              }
            </div>
            <div>
              <span class="author-name">{{ item.name }}</span>
              @if (item.designationRef?.name || item.company) {
                <span class="author-role">
                  @if (item.designationRef?.name) {
                    <span>{{ item.designationRef!.name }}</span>
                  }
                  @if (item.designationRef?.name && item.company) {
                    <span>, </span>
                  }
                  @if (item.company) {
                    <span>{{ item.company }}</span>
                  }
                </span>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</section>
